import { personArchives } from "@/mocks/homeData";

export default function Archives() {
  return (
    <section id="archives" className="border-y border-ink/10 bg-paper/60">
      <div className="shell-wrap py-14 md:py-20">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="section-eyebrow">
              <i className="ri-user-3-fill" /> 人物档案
            </p>
            <h2 className="title-serif mt-2 text-2xl font-black md:text-4xl">
              本周重点归档人物
            </h2>
          </div>
          <span className="inline-flex items-center gap-2 rounded-full border border-ink/10 bg-paper px-4 py-2 text-xs text-ink/60">
            <i className="ri-calendar-line text-ember" /> 共 1,286 篇
          </span>
        </div>

        <div className="mt-8 space-y-5">
          {personArchives.map((p) => (
            <article
              key={p.title}
              className="group card-lift grid gap-0 overflow-hidden rounded-2xl border border-ink/10 bg-paper sm:grid-cols-[240px_1fr]"
            >
              <div className="relative h-44 w-full overflow-hidden sm:h-full">
                <img
                  src={p.image}
                  alt={p.title}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-col p-5 md:p-6">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="rounded-md bg-ink px-2.5 py-1 text-[11px] font-bold text-white">
                    {p.tag}
                  </span>
                  <span className="text-xs text-ink/45">{p.meta.join(" · ")}</span>
                </div>
                <h3 className="title-serif mt-3 text-lg font-black leading-snug md:text-2xl">
                  {p.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-ink/65 md:text-base">
                  {p.desc}
                </p>
                <div className="mt-4 flex items-center gap-3">
                  <button
                    type="button"
                    className="inline-flex items-center gap-1.5 rounded-full bg-ember px-4 py-2 text-sm font-bold text-white transition-colors hover:bg-ink cursor-pointer"
                  >
                    展开人物档案 <i className="ri-arrow-right-line" />
                  </button>
                  <button
                    type="button"
                    className="inline-flex items-center gap-1.5 rounded-full border border-ink/15 px-4 py-2 text-sm font-semibold text-ink/70 transition-colors hover:border-ember hover:text-ember cursor-pointer"
                  >
                    <i className="ri-time-line" /> 看时间线
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}